import React, { Component } from 'react';
import { DynamicForm, FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { Dialog, Slide, Button, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@material-ui/core';
import Remitente from '../../Catalogos/clientes/remitentes/RemitenteNuevo';
import Destinatario from '../../Catalogos/clientes/destinatarios/DestinatarioNuevo';
// import DetallesGuia from './DocumentacionDetalles';
import DetallesGuia from './DetallesNew';
import Autorizar from '../Autorizar';
import { objectAsParams } from "../../../helpers";
import AccionesGuia from '../../../components/accionesGuia/AccionesGuia';
import { AuthContext } from "../../../context/authContext";
import ACCESS from '../../../ACCESS';
import Toast from 'react-hot-toast';
import moment from 'moment';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MODALS = {
  'NEW_REMITENTE': 100,
  'NEW_DESTINATARIO': 200,
  'DETALLES_GUIA': 300,
}

const defaultServices = [
  {
    id_lista_precio_tipo: 2,
    id_valor_aplicado: 1,
  },
  {
    id_lista_precio_tipo: 3,
    id_valor_aplicado: 1,
    valor_aplicado: 0,
    concepto: 1,
    fecha_cita_ead: null,
  },
];

class Documentacion extends Component {
  idGuia = isNaN(this.props.match.params.id) ? null : this.props.match.params.id;
  state = {
    FormData: new Form([
      Form.Section("GUÍA"),
      Form.Field("text", "g_folio", "Guia Folio", "", [], 12, [], [], [], false, true),
      Form.Field("autocomplete-async", "g_id_preguia", "Folio de Preguia Previa", "", [], 6, [], [], [], false, false, '', 'search/preguia'),
      Form.Field("date-hour", "g_fecha", "Fecha", new Date(), [], 6, [], [], [], false, true),
      Form.Field("select", "g_paga", "¿Quién paga?", "", [Validators.required], 6, [{ Value: 1, Label: "Remitente" }, { Value: 2, Label: "Destinatario" }]),
      Form.Field("select", "g_id_origen", "Origen", "", [Validators.required], 6),
      Form.Field("select", "g_id_destino", "Destino", "", [Validators.required], 6),
      Form.Field("text", "source", "Fuente", "", [], 6, [], [], [], false, true),

      Form.Section("CLIENTE"),
      Form.Field("autocomplete-async", "g_id_cliente", "Cliente", "", [Validators.required], 12, [], [], [], false, false, '', 'search/cliente'),
      Form.Field("text", "guia_cliente_rfc", "RFC", "", [Validators.required], 6, [], [], [], false, true),
      Form.Field("text", "guia_cliente_telefono", "Telefono", "", [Validators.required], 6, [], [], [], false, true),
      Form.Field("text", "guia_cliente_domicilio", "Domicilio", "", [Validators.required], 12, [], [], [], false, true),
      Form.Field("text", "guia_cliente_cp", "C.P.", "", [Validators.required], 6, [], [], [], false, true),
      Form.Field("text", "guia_cliente_colonia", "Colonia", "", [Validators.required], 6, [], [], [], false, true),
      Form.Field("text", "guia_cliente_estado", "Estado", "", [Validators.required], 6, [], [], [], false, true),
      Form.Field("text", "guia_cliente_ciudad", "Ciudad", "", [Validators.required], 6, [], [], [], false, true),
      Form.Field("hidden", "g_pedimento", "Numero de Pedimiento", "", [], 6),
      Form.Field("hidden", "prefolio_pers", "Folio (prefijo)", "", [], 3, [], [], [], false, true),
      Form.Field("hidden", "folio_pers", "Folio", "", [], 9, [], [], [], false, false),
      Form.Field("text", "g_pedido_remision_manifiesto", "Pedido/Remision/Manifiesto", "", [], 12, [], [], [], false, false),

      Form.Section("REMITENTE", 1, 4),
      Form.Space(5),
      Form.Button(3000, "Nuevo Remitente", 3),
      Form.Field("autocomplete-async", "g_id_remitente", "Remitente*", "", [Validators.required], 12, [], [], [], false, true, '', 'search/cliente-remitente'),
      // Form.Field("text", "guia_remitente_rfc", "RFC", "", [], 6, [], [], [], false, true),
      Form.Field("text", "guia_remitente_domicilio", "Domicilio", "", [], 6, [], [], [], false, true),
      Form.Field("autocomplete-async-cp", "guia_remitente_cp", "C.P.", "", [], 6, [], [], [], false, true, '', 'search/codigo-postal'),
      Form.Field("select", "guia_remitente_id_colonia", "Colonia", "", [Validators.required], 6, [], [], [], false, true),
      Form.Field("text", "guia_remitente_estado", "Estado", "", [], 6, [], [], [], false, true),
      Form.Field("text", "guia_remitente_ciudad", "Ciudad", "", [], 6, [], [], [], false, true),
      Form.Field("text", "guia_remitente_zona", "Zona", "", [], 6, [], [], [], false, true),
      Form.Field('hidden', 'rfc_rem', '- RFC REMITENTE', 2, [], 12, [], [], [], false, true),
      Form.Field('hidden', 'guia_remitente_fm', 'Persona Fisica / Moral', '', [], 6, [{ Label: 'Fisica', Value: "1" }, { Label: 'Moral', Value: "2" }]),
      Form.Field('hidden', 'guia_remitente_rfc', 'R.F.C.', '', [], 6),

      Form.Section("DESTINATARIO", 1, 4),
      Form.Space(5),
      Form.Button(4000, "Nuevo Destinatario", 3),
      Form.Field("autocomplete-async", "g_id_destinatario", "Destinatario*", "", [Validators.required], 12, [], [], [], false, true, '', 'search/cliente-destinatario'),
      // Form.Field("text", "guia_destinatario_rfc", "RFC", "", [], 6, [], [], [], false, true),
      Form.Field("text", "guia_destinatario_domicilio", "Domicilio", "", [], 6, [], [], [], false, true),
      Form.Field("autocomplete-async-cp", "guia_destinatario_cp", "C.P.", "", [], 6, [], [], [], false, true, '', 'search/codigo-postal'),
      Form.Field("select", "guia_destinatario_id_colonia", "Colonia", "", [Validators.required], 6, [], [], [], false, true),
      Form.Field("text", "guia_destinatario_estado", "Estado", "", [], 6, [], [], [], false, true),
      Form.Field("text", "guia_destinatario_ciudad", "Ciudad", "", [], 6, [], [], [], false, true),
      Form.Field("text", "guia_destinatario_zona", "Zona", "", [], 6, [], [], [], false, true),
      Form.Field('hidden', 'rfc_dest', '- RFC DESTINATARIO', 2, [], 12, [], [], [], false, true),
      Form.Field('hidden', 'guia_destinatario_fm', 'Persona Fisica / Moral', '', [], 6, [{ Label: 'Fisica', Value: "1" }, { Label: 'Moral', Value: "2" }]),
      Form.Field('hidden', 'guia_destinatario_rfc', 'R.F.C.', '', [], 6),

      Form.Field("hidden", "g_confirm_cyc", "Confirmar Pago CYC", false, [], 3),
    ], [], this.idGuia ? `Editar Guia #${this.idGuia}` : "Nueva Guia"),
    loading: true,
    loadingData: true,
    loadingError: '',
    showModal: null,
    validForm: true,
    guia: null,
    tipos_cobro: [],
    embalaje_grupos: [],
    embalajes: [],
    priceInfo: {},
    guiaDisabled: false,
    calculate: false,
  }

  constructor(props) {
    super(props);
    this.actions = React.createRef();
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.loadData();
    }
  }

  loadData = () => {
    let id = this.props.match.params.id;
    let user = this.context.user;
    this.FillForm().then((f) => {
      if (id) {
        this.LoadPreds(id).then(l => {
          this.setState({ loadingData: false, loading: false });
        }).catch(() => {
          this.setState({ loadingError: 'Error al cargar (1)', loadingData: false });
        })
      } else {
        let newForm = { ...this.state.FormData };
        newForm = Form.FieldMod(newForm, 'g_id_origen', 'Value', user.id_sucursal);
        this.setState({ 
          FormData: newForm,
          loading: false,
          loadingData: false,
          modo: 'create',
          guia: {
            servicios_incluidos: defaultServices,
            cita_ead: {
              descripcion: '',
              fecha_ead: null,
            },
            productos: [],
            paquetes: [],
            manifiestos: [],
            g_almacenaje: false,
            g_autoservicio: false,
            g_completo: false,
            g_id_tipo_precio: '1',
            g_tipo_precio_valor: null,
            id_grupo_embalaje: '1',
            g_volumen_largo: '',
            g_volumen_alto: '',
            g_volumen_ancho: '',
            g_peso_volumetrico: '0',
            g_peso_real: '0',
            g_piezas: '0',
            g_observaciones: '',
            g_dimensiones: ''
          }
        });
      }
    }).catch(() => {
      this.setState({ loadingError: 'Error al cargar (2)', loadingData: false })
    });
  }

  FillForm = async () => {
    let params = {
      g: this.idGuia || undefined
    };
    try {
      const Res = await Http.get(`guia/form?${objectAsParams(params)}`);
      if (!Res || Res.error) return Toast.error(`Error ${Res.errMsg}`);
      const { ods, embalajes, embalaje_grupos, tipos_cobro } = Res.data;
      const { FormData } = this.state;
      let newForm = { ...FormData };
      newForm = Form.FieldOptions(newForm, "g_id_origen", ods, "id", "Label");
      newForm = Form.FieldOptions(newForm, "g_id_destino", ods, "id", "Label");
      this.setState({ FormData: newForm, embalajes, embalaje_grupos, tipos_cobro });
    } catch (error) {
      this.setState({ loadingError: 'Error al cargar el Formulario' })
    }
  };

  LoadPreds = async (predId = null) => {
    let id = predId ? predId : this.props.match.params.id;
    const { FormData } = this.state;
    const { hasAccess } = this.context;
    let newForm = { ...FormData };
    try {
      let Res = await Http.get(`guia/one-new/${id}`);
      let current_id_cliente = null;
      if (Res.error) {
        this.setState({ loadingError: 'Error inesperado (1)' })
        return Toast.error('Error al cargar informacion de la guia (1)')
      }
      const guia = Res.data;
      let guia_data = {
        g_folio: guia.g_folio,
        g_id_preguia: guia.g_id_preguia,
        g_fecha: guia.g_fecha, // desactivar validacion de fecha si ya no es necesario (no es importante)
        g_paga: guia.g_paga,
        g_id_origen: guia.g_id_origen,
        g_id_destino: guia.g_id_destino,
        source: guia.source,
        g_pedido_remision_manifiesto: guia.g_pedido_remision_manifiesto,
        today_guia: moment(guia.g_fecha).isSame(new Date(), "day"),
      };
      newForm.Title = `Editar Guia ${guia_data.g_folio}`;
      [newForm, current_id_cliente] = this.onClienteChange(null, newForm, current_id_cliente, Res.data.cliente);
      newForm = this.onRemitenteChange(null, newForm, { ...Res.data.remitente, cliente_rfc_destrem: Res.data.cliente.cliente_rfc_destrem });
      newForm = this.onDestinatarioChange(null, newForm, { ...Res.data.destinatario, cliente_rfc_destrem: Res.data.cliente.cliente_rfc_destrem });
      if (!!guia.g_id_preguia) {
        newForm = Form.FieldOptions(newForm, "g_id_preguia", [{ Value: guia.g_id_preguia, Label: `${guia.g_id_preguia}` }], "Value", "Label");
      } else {
        newForm = Form.FieldMod(newForm, "g_id_preguia", "Type", 'hidden');
      }
      newForm = Form.Patch(newForm, guia_data, false);

      const userHasAccess = hasAccess(ACCESS.GUIA.EDITAR_GUIAS_SIN_RESTRICCIONES)
      let guiaDisabled = false;

      if (!userHasAccess && ([0, 21].includes(guia.g_estado) || (guia.g_estado > 1 && guia.g_estado !== 20) || guia.g_impresa || !guia.today_guia || ['API-GENERAL', 'API-ULINE'].includes(guia.source))) {
        guiaDisabled = true;
      }

      this.setState({ FormData: newForm, current_id_cliente, guia, guiaDisabled, modo: 'edit' });
    } catch (error) {
      Toast.error('Error al cargar informacion de la guia (2)')
    } finally {
      this.setState({ loadData: false })
    }
  }

  onClickAdd = async (i, vals) => {
    const { current_id_cliente, loading } = this.state;
    if (loading) return;
    if (i === 3000) {
      if (!current_id_cliente) return Toast.error('Es necesario seleccionar un cliente');
      this.setState({ showModal: MODALS.NEW_REMITENTE });
      return;
    } else if (i === 4000) {
      if (!current_id_cliente) return Toast.error('Es necesario seleccionar un cliente');
      this.setState({ showModal: MODALS.NEW_DESTINATARIO });
      return;
    }
  };

  onClienteChange = (field, newForm, current_id_cliente, data) => {
    let clienteInfo = field ? field.Options.find(o => o.Value === field.Value) : data;
    clienteInfo = clienteInfo || {}
    let cliente_data = {
      g_id_cliente: clienteInfo.id,
      guia_cliente_rfc: clienteInfo.cliente_rfc,
      guia_cliente_telefono: clienteInfo.cliente_telefono,
      guia_cliente_domicilio: clienteInfo.cliente_domicilio,
      guia_cliente_cp: clienteInfo.codigo_postal,
      guia_cliente_colonia: clienteInfo.colonia,
      guia_cliente_estado: clienteInfo.estado,
      guia_cliente_ciudad: clienteInfo.ciudad,
      prefolio_pers: clienteInfo.cliente,
    }
    if (current_id_cliente !== cliente_data.g_id_cliente) {
      const resetPatches = {
        g_id_remitente: null,
        guia_remitente_rfc: '',
        guia_remitente_domicilio: "",
        guia_remitente_cp: null,
        guia_remitente_id_colonia: "",
        guia_remitente_estado: "",
        guia_remitente_ciudad: "",
        guia_remitente_zona: "",

        g_id_destinatario: null,
        guia_destinatario_rfc: '',
        guia_destinatario_domicilio: "",
        guia_destinatario_cp: null,
        guia_destinatario_id_colonia: "",
        guia_destinatario_estado: "",
        guia_destinatario_ciudad: "",
        guia_destinatario_zona: "",
      };
      newForm = Form.FieldMod(newForm, "g_id_remitente", "ApiUrl", `search/cliente-remitente/${clienteInfo.id}`);
      newForm = Form.FieldMod(newForm, "g_id_remitente", "Disabled", !clienteInfo.id);
      newForm = Form.FieldMod(newForm, "g_id_remitente", "Reset", true);
      newForm = Form.FieldMod(newForm, "guia_remitente_cp", "Reset", true);
      newForm = Form.FieldOptions(newForm, "g_id_remitente", [], "Value", "Label");
      newForm = Form.FieldOptions(newForm, "guia_remitente_cp", [], "Value", "Label");
      newForm = Form.FieldOptions(newForm, "guia_remitente_id_colonia", [], "Value", "Label");

      newForm = Form.FieldMod(newForm, "g_id_destinatario", "ApiUrl", `search/cliente-destinatario/${clienteInfo.id}`);
      newForm = Form.FieldMod(newForm, "g_id_destinatario", "Disabled", !clienteInfo.id);
      newForm = Form.FieldMod(newForm, "g_id_destinatario", "Reset", true);
      newForm = Form.FieldMod(newForm, "guia_destinatario_cp", "Reset", true);
      newForm = Form.FieldOptions(newForm, "g_id_destinatario", [], "Value", "Label");
      newForm = Form.FieldOptions(newForm, "guia_destinatario_cp", [], "Value", "Label");
      newForm = Form.FieldOptions(newForm, "guia_destinatario_id_colonia", [], "Value", "Label");
      newForm = Form.Patch(newForm, resetPatches);
    }
    const importacion = clienteInfo.cliente_importacion
    const confirm_cyc = (clienteInfo.cliente_id_condicion_pago && Number(clienteInfo.cliente_id_condicion_pago) === 8);
    newForm = Form.FieldMod(newForm, "prefolio_pers", "Type", clienteInfo.cliente_uso_folios ? "text" : 'hidden');
    newForm = Form.FieldMod(newForm, "folio_pers", "Type", clienteInfo.cliente_uso_folios ? "text" : 'hidden');
    newForm = Form.FieldMod(newForm, "g_pedimento", "Type", importacion ? "text" : 'hidden');
    newForm = Form.FieldMod(newForm, "g_confirm_cyc", "Type", confirm_cyc ? "checkbox" : 'hidden');
    if (!field && !!data) {
      newForm = Form.FieldMod(newForm, "g_id_cliente", 'Options', [{ Value: data.id, Label: `[${data.cliente_rems}] ${data.cliente_rems_nombre}`, ...data }]);
      newForm = Form.FieldMod(newForm, "g_id_cliente", 'Value', data.id);
    }

    // rfc remitente y destinatarios
    newForm = Form.FieldMod(newForm, "rfc_rem", "Type", clienteInfo.cliente_rfc_destrem ? "section" : 'hidden');
    newForm = Form.FieldMod(newForm, "guia_remitente_fm", "Type", clienteInfo.cliente_rfc_destrem ? "radio" : 'hidden');
    newForm = Form.FieldMod(newForm, "guia_remitente_fm", "Validators", clienteInfo.cliente_rfc_destrem ? [Validators.required] : []);
    newForm = Form.FieldMod(newForm, "guia_remitente_rfc", "Type", clienteInfo.cliente_rfc_destrem ? "text" : 'hidden');
    newForm = Form.FieldMod(newForm, "guia_remitente_rfc", "Validators", clienteInfo.cliente_rfc_destrem ? [Validators.required] : []);
    newForm = Form.FieldMod(newForm, "rfc_dest", "Type", clienteInfo.cliente_rfc_destrem ? "section" : 'hidden');
    newForm = Form.FieldMod(newForm, "guia_destinatario_fm", "Type", clienteInfo.cliente_rfc_destrem ? "radio" : 'hidden');
    newForm = Form.FieldMod(newForm, "guia_destinatario_fm", "Validators", clienteInfo.cliente_rfc_destrem ? [Validators.required] : []);
    newForm = Form.FieldMod(newForm, "guia_destinatario_rfc", "Type", clienteInfo.cliente_rfc_destrem ? "text" : 'hidden');
    newForm = Form.FieldMod(newForm, "guia_destinatario_rfc", "Validators", clienteInfo.cliente_rfc_destrem ? [Validators.required] : []);

    newForm = Form.Patch(newForm, cliente_data);
    current_id_cliente = clienteInfo.id;
    return [newForm, current_id_cliente, clienteInfo]
  }

  onRemitenteChange = (field, newForm, data) => {
    let remitenteInfo = field ? field.Options.find(o => o.Value === field.Value) : data;
    remitenteInfo = remitenteInfo || {}
    let remitente_data = {
      g_id_remitente: remitenteInfo.id || '',
      guia_remitente_domicilio: remitenteInfo.cliente_rems_domicilio || '',
      guia_remitente_rfc: remitenteInfo.cliente_rems_rfc || '',
      guia_remitente_cp: remitenteInfo.codigo_postal || '',
      guia_remitente_estado: remitenteInfo.estado || '',
      guia_remitente_ciudad: remitenteInfo.ciudad || '',
      guia_remitente_id_colonia: [null, '', undefined].includes(remitenteInfo.cliente_rems_id_colonia) ? '' : `${remitenteInfo.cliente_rems_id_colonia}`,
      guia_remitente_zona: remitenteInfo.zona ? `${remitenteInfo.zona} - ${remitenteInfo.zona_descripcion}` : '',
      guia_remitente_fm: remitenteInfo.cliente_rems_fm ? remitenteInfo.cliente_rems_fm + '' : null,
    }
    const hasRfc = !['', null].includes(remitente_data.guia_remitente_rfc) || remitenteInfo.cliente_rfc_destrem;
    const valiRfc = remitente_data.guia_remitente_fm == 1 ? Validators.rfc_fisica : Validators.rfc_moral;
    newForm.Fields = newForm.Fields.map(f => {
      if (f.Name === 'guia_remitente_id_colonia') {
        f.Options = ![null, '', undefined].includes(remitenteInfo.cliente_rems_id_colonia) ? [{ Value: remitenteInfo.cliente_rems_id_colonia, Label: remitenteInfo.colonia }] : [];
        f.Disabled = !remitenteInfo.id
      }
      if (f.Name === 'guia_remitente_cp') {
        f.Disabled = !remitenteInfo.id;
        f.Options = remitenteInfo.codigo_postal ? [{ Value: remitenteInfo.codigo_postal, Label: remitenteInfo.codigo_postal }] : [];
        f.Reset = !remitenteInfo.id ? true : false;
      }
      if (f.Name === 'guia_remitente_fm') {
        f.Validators = hasRfc ? [Validators.required] : [];
        f.Type = hasRfc ? 'radio' : 'hidden';
      }
      if (f.Name === 'guia_remitente_rfc') {
        f.Disabled = !remitenteInfo.id;
        f.Validators = hasRfc ? [Validators.required, valiRfc] : []
        f.Type = hasRfc ? 'text' : 'hidden';
      }
      if (f.Name === 'rfc_rem') {
        f.Type = hasRfc ? 'section' : 'hidden';
      }
      if (f.Name === 'guia_remitente_domicilio') {
        f.Disabled = !remitenteInfo.id
      }
      if (!field && !!data && f.Name === 'g_id_remitente') {
        f.Options = [{ Value: data.id, Label: `[${data.cliente_rems}] ${data.cliente_rems_nombre}`, ...data }]
        f.Value = data.id
        f.Disabled = false;
      }
      return f;
    })
    return Form.Patch(newForm, remitente_data);
  }

  onRemitenteCpChange = (field, newForm) => {
    let remitenteCP = field.Options.find(o => o.Value === field.Value) || {};
    let remitente_data = {
      guia_remitente_estado: remitenteCP.estado || '',
      guia_remitente_ciudad: remitenteCP.ciudad || '',
      guia_remitente_zona: remitenteCP.zona ? `${remitenteCP.zona} - ${remitenteCP.zona_descripcion}` : '',
      guia_remitente_id_colonia: null,
    }
    newForm.Fields = newForm.Fields.map(f => {
      if (f.Name === 'guia_remitente_id_colonia') {
        f.Options = remitenteCP.colonias ? remitenteCP.colonias : [];
      }
      return f;
    });
    newForm = Form.Patch(newForm, remitente_data);
    return newForm;
  }

  onRemitenteFMChange = (field, newForm) => {
    const valiRfc = field.Value == 1 ? Validators.rfc_fisica : Validators.rfc_moral;
    newForm = Form.FieldMod(newForm, "guia_remitente_rfc", "Validators", [Validators.required, valiRfc]);
    return newForm;
  }

  onNewRemitente = (data) => {
    const { FormData, guia } = this.state
    let newForm = { ...FormData };
    newForm = this.onRemitenteChange(null, newForm, { ...data, cliente_rfc_destrem: guia.cliente.cliente_rfc_destrem });
    let newGuia = {
      ...guia,
      ...(Form.FieldsValues(newForm))
    };
    this.setState({ showModal: null, newForm, guia: newGuia });
  };

  onDestinatarioChange = (field, newForm, data) => {
    let destinatarioInfo = field ? field.Options.find(o => o.Value === field.Value) : data;
    destinatarioInfo = destinatarioInfo || {}
    let destinatario_data = {
      g_id_destinatario: destinatarioInfo.id || '',
      guia_destinatario_rfc: destinatarioInfo.cliente_dests_rfc || '',
      guia_destinatario_domicilio: destinatarioInfo.cliente_dests_domicilio || '',
      guia_destinatario_cp: destinatarioInfo.codigo_postal || '',
      guia_destinatario_id_colonia: [null, '', undefined].includes(destinatarioInfo.cliente_dests_id_colonia) ? '' : `${destinatarioInfo.cliente_dests_id_colonia}`,
      guia_destinatario_estado: destinatarioInfo.estado || '',
      guia_destinatario_ciudad: destinatarioInfo.ciudad || '',
      guia_destinatario_zona: destinatarioInfo.zona ? `${destinatarioInfo.zona} - ${destinatarioInfo.zona_descripcion}` : '',
      guia_destinatario_fm: destinatarioInfo.cliente_dests_fm ? destinatarioInfo.cliente_dests_fm + '' : null,
    }
    const hasRfc = !['', null].includes(destinatario_data.guia_destinatario_rfc) || destinatarioInfo.cliente_rfc_destrem;;
    const valiRfc = destinatario_data.guia_destinatario_fm == 1 ? Validators.rfc_fisica : Validators.rfc_moral;
    newForm.Fields = newForm.Fields.map(f => {
      if (f.Name === 'guia_destinatario_id_colonia') {
        f.Options = ![null, '', undefined].includes(destinatarioInfo.cliente_dests_id_colonia) ? [{ Value: destinatarioInfo.cliente_dests_id_colonia, Label: destinatarioInfo.colonia }] : [];
        f.Disabled = !destinatarioInfo.id
      }
      if (f.Name === 'guia_destinatario_cp') {
        f.Disabled = !destinatarioInfo.id
        f.Options = destinatarioInfo.codigo_postal ? [{ Value: destinatarioInfo.codigo_postal, Label: destinatarioInfo.codigo_postal }] : [];
        f.Reset = !destinatarioInfo.id ? true : false;
      }
      if (f.Name === 'guia_destinatario_fm') {
        f.Validators = hasRfc ? [Validators.required] : [];
        f.Type = hasRfc ? 'radio' : 'hidden';
      }
      if (f.Name === 'guia_destinatario_rfc') {
        f.Disabled = !destinatarioInfo.id;
        f.Validators = hasRfc ? [Validators.required, valiRfc] : []
        f.Type = hasRfc ? 'text' : 'hidden';
      }
      if (f.Name === 'rfc_dest') {
        f.Type = hasRfc ? 'section' : 'hidden';
      }
      if (f.Name === 'guia_destinatario_domicilio') {
        f.Disabled = !destinatarioInfo.id
      }
      if (!field && !!data && f.Name === 'g_id_destinatario') {
        f.Options = [{ Value: data.id, Label: `[${data.cliente_dests}] ${data.cliente_dests_nombre}`, ...data }]
        f.Value = data.id
        f.Disabled = false;
      }
      return f;
    })
    return Form.Patch(newForm, destinatario_data);
  }

  onDestinatarioCpChange = (field, newForm) => {
    let destinatarioCP = field.Options.find(o => o.Value === field.Value) || {};
    let destinatario_data = {
      guia_destinatario_estado: destinatarioCP.estado || '',
      guia_destinatario_ciudad: destinatarioCP.ciudad || '',
      guia_destinatario_zona: destinatarioCP.zona ? `${destinatarioCP.zona} - ${destinatarioCP.zona_descripcion}` : '',
      guia_destinatario_id_colonia: null || '',
    }
    newForm.Fields = newForm.Fields.map(f => {
      if (f.Name === 'guia_destinatario_id_colonia') {
        f.Options = destinatarioCP.colonias ? destinatarioCP.colonias : [];
      }
      return f;
    });
    newForm = Form.Patch(newForm, destinatario_data);
    return newForm;
  }

  onDestinatarioFMChange = (field, newForm) => {
    const valiRfc = field.Value == 1 ? Validators.rfc_fisica : Validators.rfc_moral;
    newForm = Form.FieldMod(newForm, "guia_destinatario_rfc", "Validators", [Validators.required, valiRfc]);
    return newForm;
  }

  onNewDestinatario = (data) => {
    const { FormData, guia } = this.state;
    let newForm = { ...FormData };
    newForm = this.onDestinatarioChange(null, newForm, { ...data, cliente_rfc_destrem: guia.cliente.cliente_rfc_destrem });
    let newGuia = {
      ...guia,
      ...(Form.FieldsValues(newForm))
    };
    this.setState({ showModal: null, newForm, guia: newGuia });
  };

  onPreguiaChange = async (field, newForm) => {
    let preguiaInfo = field ? field.Options.find(o => o.Value === field.Value) : {};
    let guia_data = {};
    let current_id_cliente = null;
    if (preguiaInfo) {
      const res = await Http.post('preguia/preguia-guia', { id_preguia: preguiaInfo.id });
      if (res.error) Toast.error('Error inesperado al cargar la guia');
      if (res.data) {
        const preguia = res.data;
        guia_data = {
          g_id_origen: preguia.origen_id_sucursal,
          paquetes: preguia.paquetes.map(prod => {
            return {
              ...prod,
              gp_precio: '',
              gp_tipo_cobro: '',
            }
          }),
          productos: preguia.productos,
          id_grupo_embalaje: preguia.id_grupo_embalaje,
          g_peso_real: preguia.pg_peso,
          g_observaciones: preguia.pg_observaciones,
          cliente: preguia.cliente,
          remitente: { ...preguia.remitente, cliente_rfc_destrem: preguia.cliente.cliente_rfc_destrem},
          destinatario: { ...preguia.destinatario, cliente_rfc_destrem: preguia.cliente.cliente_rfc_destrem},
          servicios_incluidos: [...this.state.guia.servicios_incluidos, 
            {
              id_lista_precio_tipo: 1,
              id_valor_aplicado: 1,
            }
          ],

        };
        [newForm, current_id_cliente] = this.onClienteChange(null, newForm, current_id_cliente, preguia.cliente)
        newForm = this.onRemitenteChange(null, newForm, { ...preguia.remitente, cliente_rfc_destrem: preguia.cliente.cliente_rfc_destrem})
        newForm = this.onDestinatarioChange(null, newForm, { ...preguia.destinatario, cliente_rfc_destrem: preguia.cliente.cliente_rfc_destrem})
        newForm = Form.Patch(newForm, guia_data);
      }
    }

    return [newForm, guia_data, current_id_cliente]
  }

  formChange = async (form, field, type) => {
    let { current_id_cliente, guia } = this.state;
    let cliente = null;
    let newForm = { ...form };
    let newGuia = {
      ...guia,
      ...(Form.FieldsValues(form))
    };
    if (field.Name === 'g_id_cliente' && type !== 'options') {
      [newForm, current_id_cliente, cliente] = this.onClienteChange(field, form, current_id_cliente);
      newGuia = {
        ...newGuia,
        cliente,
        id_grupo_embalaje: cliente.cliente_id_grupo_embalaje
      }
    } else if (field.Name === 'g_id_remitente' && type !== 'options') {
      newForm = this.onRemitenteChange(field, newForm)
    } else if (field.Name === 'guia_remitente_cp' && type !== 'options') {
      newForm = this.onRemitenteCpChange(field, newForm)
    } else if (field.Name === 'guia_remitente_fm' && type !== 'options') {
      newForm = this.onRemitenteFMChange(field, newForm)
    } else if (field.Name === 'g_id_destinatario' && type !== 'options') {
      newForm = this.onDestinatarioChange(field, newForm)
    } else if (field.Name === 'guia_destinatario_cp' && type !== 'options') {
      newForm = this.onDestinatarioCpChange(field, newForm)
    } else if (field.Name === 'guia_destinatario_fm' && type !== 'options') {
      newForm = this.onDestinatarioFMChange(field, newForm)
    } else if (field.Name === 'g_id_preguia' && type !== 'options') {
      [newForm, guia, current_id_cliente] = await this.onPreguiaChange(field, newForm)
      newGuia = {
        ...newGuia,
        ...guia
      }
    }

    this.setState({ FormData: newForm, current_id_cliente, guia: newGuia });
  }

  onDetallesGuia = (i, vals) => {
    const { FormData, loading, guia } = this.state;
    if (loading) return;
    let valid = Form.ValidateForm(FormData);
    // console.log(object);
    if (valid !== true) {
      return Toast.error(`Error en el campo '${valid.name}'`)
    } else {
      let newGuia = {
        ...guia,
        ...(Form.FieldsValues(FormData))
      };
      if (!this.idGuia) {
        const cliente = FormData.Fields.find(f => f.Name === 'g_id_cliente')?.Options.find(op => op.Value == newGuia.g_id_cliente);
        if (cliente.cliente_cpac) {
          newGuia.servicios_incluidos = [...newGuia.servicios_incluidos, {
            id_lista_precio_tipo: 10,
            id_valor_aplicado: 1,
            valor_aplicado: 0,
            concepto: 1,
            fecha_cita_ead: null,
          }]
        }
      }
      this.setState({ showModal: MODALS.DETALLES_GUIA, validForm: true, guia: newGuia });
    }
  }

  onGuiaChange = (value, key) => {
    const { guia } = this.state;
    guia[key] = value;

    if (key === 'remisiones_nuevas' && Array.isArray(value) && value.length > 0) {
      const remsStr = value.join(', ');
      guia.g_pedido_remision_manifiesto = remsStr;
      if (!guia.g_observaciones || !`${guia.g_observaciones}`.trim().length) {
        guia.g_observaciones = remsStr;
      }
    }

    if (key === 'id_grupo_embalaje' && guia.paquetes && guia.paquetes.length > 0) {
      let newPaq = [...guia.paquetes].map(p => {
        return {
          ...p,
          gp_id_embalaje: '',
        }
      });
      guia['paquetes'] = newPaq;
    }
    this.setState({ guia, calculate: true });
  }

  addPaquete = () => {
    const { guia } = this.state;
    let newGuia = { ...guia };
    let newPaquetes = [...guia.paquetes];
    newPaquetes.push({
      gp_cantidad: 1,
      gp_id_unidad: '',
      gp_id_producto: '',
      gp_id_embalaje: '',
      gp_descripcion: '',
      gp_peso: '',
      gp_precio: '',
      gp_tipo_cobro: '',
      unidad_options: [],
      producto_options: [],
    });
    newGuia.paquetes = newPaquetes;
    this.setState({ guia: newGuia, calculate: true });
  }

  onPaqueteChange = (index, key, value) => {
    const { guia } = this.state;
    let newGuia = { ...guia };
    let newPaq = [...newGuia.paquetes];
    newPaq[index][key] = value;
    newGuia.paquetes = newPaq;

    if (!guia.id_guia) {
      newGuia.productos = newPaq.map(paq => ({
        cantidad: paq.gp_cantidad,
        peso: paq.gp_peso,
        descripcion: paq.gp_descripcion,
        id_unidad: paq.gp_id_unidad,
        unidad_options: paq.unidad_options,
        producto_options: paq.producto_options,
        id_producto: paq.gp_id_producto,
      }))
    }

    newGuia.g_peso_real = newGuia.paquetes.map((paq) => paq.gp_peso)
      .reduce((paq, current) => Number(paq) + Number(current));
    newGuia.g_piezas = newGuia.paquetes.map((paq) => paq.gp_cantidad)
      .reduce((paq, current) => Number(paq) + Number(current));
    this.setState({ guia: newGuia, calculate: true });
  }

  onPaqueteDelete = (index) => {
    const { guia } = this.state;
    let newGuia = { ...guia };
    newGuia.paquetes = guia.paquetes.filter((p, i) => i !== index)
    this.setState({ guia: newGuia, calculate: true });
  }

  onProductosChange = (productos = []) => {
    const { guia } = this.state;
    let newGuia = { ...guia };
    newGuia.productos = [...productos]
    this.setState({ guia: newGuia, calculate: true });
  }

  setPrecio = (data) => {
    const { guia, tipos_cobro, priceInfo }=  this.state;
    for (const [index, paquete] of data.Paquetes.entries()) {
      guia.paquetes[index]["gp_precio"] = Number(paquete.gp_precio).toFixed(3);
      guia.paquetes[index]["gp_tipo_cobro"] = paquete.gp_tipo_cobro;
      guia.paquetes[index]["gp_id_especificacion_aplicada"] = paquete.gp_id_especificacion_aplicada;
    }
    for (const tipoCobro of tipos_cobro) {
      guia[`tipo_${tipoCobro.id}`] = data[`tipo_${tipoCobro.id}`] ? data[`tipo_${tipoCobro.id}`].valor_aplicado : 0;
      priceInfo[`tipo_${tipoCobro.id}`] = {
        lp: data[`tipo_${tipoCobro.id}`] ? data[`tipo_${tipoCobro.id}`].tipo_cobro : null,
        km: data[`tipo_${tipoCobro.id}`] ? data[`tipo_${tipoCobro.id}`].KM : null,
      };
    }
    guia.g_costo_subtotal = Number(data.g_costo_subtotal.valor_aplicado).toFixed(2);
    guia.g_costo_iva = Number(data.g_costo_iva.valor_aplicado).toFixed(2);
    guia.g_costo_retencion = Number(data.g_costo_retencion.valor_aplicado).toFixed(2);
    guia.g_costo_total = Number(data.g_costo_total.valor_aplicado).toFixed(2);
    guia.factor_cpac = data.factor_cpac;
    guia.cobros_aplicados = { ...data, Paquetes: undefined };
    
    this.setState({ guia, priceInfo });
  }

  onSelectManifiesto = (rows) => {
    let { guia } = this.state;
    guia["g_observaciones"] = rows.map((row) => row.orden).join(", ");
    this.setState({
      guia: {
        ...guia,
        manifiestos: rows.map(r => r.id),
      }
    });
  };

  onSaveGuia = (e) => {
    e.preventDefault();
    let { loadingSave, guia, guiaDisabled, redocumentar } = this.state;
    if (loadingSave || guiaDisabled) return;

    const valid  =[
      { key: "g_id_tipo_precio", name: "Tipo de Precio" },
      { key: "id_grupo_embalaje", name: "Grupo de Embalaja" },
      { key: "g_peso_real", name: "Peso" },
      { key: "g_piezas", name: "Unidades" },
    ];
    const isInvalid = valid.find(v => [null, ''].includes(guia[v.key]));
    if (isInvalid) return Toast.error(`El campo ${isInvalid.name} es requerido`);
    const isProductoInvalid = guia.productos.some(p => !p.id_unidad || !p.id_producto || !p.descripcion || !p.peso || !p.cantidad < 0);
    if (isProductoInvalid) return Toast.error(`Verificar los productos`);
    const isPaqueteInvalid = guia.paquetes.some(p => !p.gp_id_unidad || !p.gp_id_producto || !p.gp_descripcion || !p.gp_peso || p.gp_cantidad < 0 || !p.gp_id_embalaje);
    if (isPaqueteInvalid) return Toast.error(`Verificar los paquetes`);
    if (guia.cita_ead && guia.cita_ead.tiene_cita && !guia.cita_ead.fecha_ead) {
      return Toast.error(`Es necesario definir la Fecha y Hora de la cita EAD`);
    }

    // Remisiones en documentación: no son obligatorias, se pueden dejar en blanco

    if (guia.remisiones_nuevas && Array.isArray(guia.remisiones_nuevas) && guia.remisiones_nuevas.length > 0) {
      const remsTrimmed = Array.from(new Set(guia.remisiones_nuevas.map(r => `${r}`.trim()).filter(Boolean)));
      const remsStr = remsTrimmed.join(', ');
      guia.g_pedido_remision_manifiesto = remsStr;
      if (!guia.g_observaciones || !`${guia.g_observaciones}`.trim().length) {
        guia.g_observaciones = remsStr;
      } else {
        const obsTokens = `${guia.g_observaciones}`.split(/[,\s/]+/).map(t => t.trim()).filter(Boolean);
        const allTokensInObs = remsTrimmed.length > 0 && remsTrimmed.every(t => obsTokens.includes(t));
        if (!allTokensInObs) {
          guia.g_observaciones = `${remsStr} / ${guia.g_observaciones}`;
        }
      }
    }

    this.setState({ loadingSave: true });
    if (redocumentar) {
      // delete guia.id;
      let Res = Http.post(`guia/${guia.id}/redocumentar`, {
        guia,
        paquetes: guia.paquetes,
        productos: guia.productos,
        cobrosAplicados: guia.cobros_aplicados,
        serviciosIncluidos: guia.servicios_incluidos,
        manifiestosId: guia.manifiestos,
      });
      Res.then(res => {
        if (res.error) return Toast.error(res.errMsg);
        Toast.success('Se ha redocumentado correctamente.');
        this.props.history.push(`/Guias/Guia/${res.data.id}`);
      }).catch(() => {
        Toast.error('Error inesperado en redocumentacion');
      }).finally(() => {
        this.setState({ loadingSave: false });
      });
      return;
    }

    //save data
    const res = guia.id_guia ? Http.post('guia/update', { guia }) : Http.post('guia/savenew', { guia });

    res.then(data => {
      if (data.error) return Toast.error(data.errMsg);
      this.idGuia = data.data.id
      Toast.success(`Se ha ${guia.id_guia ? 'editado' : 'guardado'} correctamente. 
        Folio: #${data.data.g_folio}`);
        this.actions.current.handlePrintClick(data.data.id, data.data.g_folio);
        this.setState({ 
          loading: false, 
          showModal: null, 
          guia: {
            ...guia,
            g_folio: data.data.g_folio,
            id: data.data.id,
            id_guia: data.data.id,
          }
        });
        return this.props.history.push(`/Guias/Guia/${data.data.id}`);
    }).catch((err) => {
      console.error(err)
      return Toast.error('Error inesperado al guardar la guia (GUIA-99)')
    }).finally(() => {
      this.setState({ loadingSave: false });
    });
  }

  addCitaEAD = (servicios, cita_ead) =>{
    this.setState({
      guia: {
        ...this.state.guia,
        cita_ead,
        servicios_incluidos: servicios,
      },
      calculate: true,
    })
  }

  onSelectFolio = async (value) => {
    this.props.history.push(`/Guias/Guia/${value.id}`);
  };

  modoRedocumentacion = () => {
    this.setState({ redocumentar: true, guiaDisabled: false, modo: 'redocumentacion' });
  };

  render() {
    const {
      redocumentar,
      guiaDisabled,
      FormData,
      showModal,
      current_id_cliente,
      loadingData,
      loadingError,
      loadingSave,
      validForm = false,
      embalajes,
      embalaje_grupos,
      tipos_cobro,
      guia,
      priceInfo,
      modo,
      calculate,
    } = this.state;

    if (loadingData) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <CircularProgress size={"50px"} color="primary" />
        <div><h3>Cargando...</h3></div>
      </div>
    }

    if (loadingError) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <h3>{loadingError}</h3>
      </div>
    }

    return (
      <div>
        {redocumentar && (
          <h2>Atención: Esta guia está en Modo Redocumentación</h2>
        )}
        
        <AccionesGuia
          ref={this.actions}
          modo={modo}
          guia={guia}
          onRedocumentar={this.modoRedocumentacion}
          onSelectFolio={this.onSelectFolio}
        />

        {guia && (guia.g_fecha_estimada_entrega || guia.g_zona_km) && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '16px',
            backgroundColor: '#e8f4fd',
            color: '#0d47a1',
            padding: '10px 16px',
            borderRadius: '6px',
            margin: '10px 0',
            border: '1px solid #bbdefb',
            fontSize: '14px',
            fontWeight: 500
          }}>
            <div><strong>Zona Reparto:</strong> {guia.g_zona_km} ({guia.g_distancia_km || 0} KM)</div>
            <div><strong>Tiempo Estimado:</strong> {guia.g_tiempo_estimado_hrs || 0} HRS</div>
            {guia.g_fecha_estimada_entrega && (
              <div><strong>Fecha Estimada de Entrega:</strong> {moment(guia.g_fecha_estimada_entrega).format('DD/MM/YYYY HH:mm')}</div>
            )}
          </div>
        )}

        <DynamicForm
          form={FormData}
          disabled={guiaDisabled}
          formChange={this.formChange}
          onSubmit={this.onClickAdd}
        />

        <div style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'flex-end',
          marginTop: 10,
        }} >
          <Button
            variant='contained'
            onClick={this.onDetallesGuia}
            color='primary'>
            {`Detalles Carga`}
          </Button>
        </div>

        {/* Modal Nuevo Remitente */}
        <div>
          <Dialog
            onClose={() => { this.setState({ showModal: null }) }}
            open={showModal === MODALS.NEW_REMITENTE && !!current_id_cliente}
            fullWidth={true}
            maxWidth={"xl"}
          >
            <DialogContent dividers>
              <Remitente
                cliente={current_id_cliente}
                onSave={this.onNewRemitente}
                onCancel={() => { this.setState({ showModal: null }) }}
              />
            </DialogContent>
          </Dialog>
        </div>

        {/* Modal Nuevo Destinatario */}
        <div>
          <Dialog
            onClose={() => { this.setState({ showModal: null }) }}
            open={showModal === MODALS.NEW_DESTINATARIO && !!current_id_cliente}
            fullWidth={true}
            maxWidth={"xl"}
          >
            <DialogContent dividers>
              <Destinatario
                cliente={current_id_cliente}
                onSave={this.onNewDestinatario}
                onCancel={() => { this.setState({ showModal: null }); }}
              />
            </DialogContent>
          </Dialog>
        </div>

        {/* Modal Detalles Documentacion */}
        <div>
          <Dialog
            fullScreen
            open={showModal === MODALS.DETALLES_GUIA && validForm}
            onClose={() => { this.setState({ showModal: null }) }}
            TransitionComponent={Transition}
          >
            <div style={{ textAlign: "right" }}>
              <Button onClick={() => { this.setState({ showModal: null }) }}>REGRESAR</Button>
            </div>
            <div>
              <DetallesGuia
                embalajes={embalajes}
                embalaje_grupos={embalaje_grupos}
                tipos_cobro={tipos_cobro}
                guia={guia}
                disabled={guiaDisabled || loadingSave}
                loadingSave={loadingSave}
                priceInfo={priceInfo}
                setPrecio={this.setPrecio}
                onSelectManifiesto={this.onSelectManifiesto}
                onGuiaChange={this.onGuiaChange}
                onAddPaquete={this.addPaquete}
                onPaqueteChange={this.onPaqueteChange}
                onPaqueteDelete={this.onPaqueteDelete}
                onProductosChange={this.onProductosChange}
                onSaveGuia={this.onSaveGuia}
                addCitaEAD={this.addCitaEAD}
                calculate={calculate}
              />
            </div>
          </Dialog>
        </div>

        {/* Modal Folio de guia */}
        <div>
          {/*           <Dialog onClose={() => { this.setState({ folioOpen: false }) }} open={folioOpen ? folioOpen : false}>
            <DialogTitle onClose={() => { this.setState({ folioOpen: false }) }}>
              Folio de guía: <span style={{fontWeight: 'bolder'}}>{guiaFolio}</span>
            </DialogTitle>
            <DialogActions>
              <Button autoFocus onClick={() => { this.setState({ folioOpen: false }) }} color="primary">
                Aceptar
              </Button>
            </DialogActions>
          </Dialog> */}
        </div>

        {/* Modal Guia Diferente Origen */}
        {/*         <div>
          <Dialog
            onClose={() => this.autorizarClose()}
            open={!!autorizarOpen}
            fullWidth={true}
            maxWidth={"md"}
          >
            <DialogTitle onClose={() => this.autorizarClose()}>
              Esta Seleccionando una Sucursal a la que no Pertenece, Se Requiere
              Autorizacion Para Continuar.
            </DialogTitle>
            <DialogContent dividers>
              <Autorizar onSave={this.autorizarClose} />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.autorizarClose()}>CANCELAR</Button>
            </DialogActions>
          </Dialog>
        </div> */}
      </div>
    );
  }
}
Documentacion.contextType = AuthContext;
export default withRouter(Documentacion);
